<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">모델링 요약</div>
      </div>
      <div class="vertical-center-box">
        <el-button class="mr-r4" @click="clickPreStep" :disabled="!isLoaded">전단계</el-button>
        <el-button class="mr-r4" v-show="!isUpdateFlag" type="primary" @click="executeAutodiscovery('modeling')" :disabled="!isLoaded">모델링 실행</el-button>
        <el-button class="mr-r4" v-show="isUpdateFlag" type="primary" @click="executeAutodiscovery('save')" :disabled="!isLoaded">저장</el-button>
        <el-button v-show="isUpdateFlag" type="primary" @click="executeAutodiscovery('saveAndModeling')" :disabled="!isLoaded">저장 후 실행</el-button>
      </div>
    </el-row>
    <div class="list form-list">
      <el-form ref="summaryForm" :model="summaryFormData" label-width="120px">
        <el-form-item label="IP 검색 대역">
          <w-text-form :modifiable="false" :target="summaryFormData" property="ipSearchText" type="html">
          </w-text-form>
        </el-form-item>
        <el-form-item label="Telnet / SSH">
          <w-text-form :modifiable="false" :target="summaryFormData" property="connectionText" type="html">
          </w-text-form>
        </el-form-item>
        <el-form-item label="스케줄 여부">
          <w-text-form :modifiable="false" :target="summaryFormData" property="scheduleContent">
          </w-text-form>
        </el-form-item>
      </el-form>
    </div>
  </div>

</template>

<script>
import isNil from 'lodash/isNil';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import msgUtil from '@/utils/message';
import { MONTH, WEEK, TIME, MINUTE } from '@/constants/date';
import WTextForm from '@/components/formeditor/TextFormEditor';
import DeviceRegistrationNmsAPI from '@/api/settings/common/device-registration-nms';

export default {
  name: 'WModelingSummary',
  components: {
    WTextForm,
  },
  props: {
    checkedIpSearchRows: Array,
    checkedConnectionRows: Array,
    scheduleData: Object,
  },
  data() {
    return {
      isUpdateFlag: false,
      isLoaded: false,
      summaryFormData: {
        ipSearchText: null,
        connectionText: null,
        scheduleContent: null,
      },
    };
  },
  mounted() {
    if (!isNil(this.scheduleData)) {
      if (!isNil(this.scheduleData.scheduleId)) {
        this.isUpdateFlag = true;
      }
    }
    this.loadData();
  },
  methods: {
    loadData() {
      this.isLoaded = false;
      if (this.checkedIpSearchRows.length > 0) {
        let ipSearchText = '';
        this.checkedIpSearchRows.forEach((object) => {
          if (isEqual(object.scanType, 'SPOT')) {
            const tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress} / 스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            ipSearchText = `${ipSearchText}${tempText}`;
          } else {
            let exceptAddress = '';
            if (!isNil(object.exceptStartAddress) && !isEqual(object.exceptStartAddress, '')) {
              exceptAddress = `(예외구간:${object.exceptStartAddress}~${object.exceptEndAddress}) `;
            }
            let tempText = null;
            if (isEqual(object.scanType, 'RANGE')) {
              tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress}~${object.endAddress} ${exceptAddress}/ 스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            } else {
              tempText = `[${this.scanTypeFormatter(object.scanType)}] ${object.startAddress} / 서브넷:${object.endAddress} ${exceptAddress}/ 스캔방식:${isNil(object.credentialName) ? '없음' : object.credentialName}<br />`;
            }
            ipSearchText = `${ipSearchText}${tempText}`;
          }
        });
        this.summaryFormData.ipSearchText = ipSearchText;
      }
      if (this.checkedConnectionRows.length > 0) {
        let connectionText = '';
        this.checkedConnectionRows.forEach((object) => {
          const tempText = `${object.credentialTypeId} (${object.templateName})<br />`;
          connectionText = `${connectionText}${tempText}`;
        });
        this.summaryFormData.connectionText = connectionText;
      }
      if (!isNil(this.scheduleData)) {
        const scheduleData = this.scheduleData;
        let scheduleContent = null;
        if (scheduleData.checkScheduleFlag) {
          const schedulePeriod = scheduleData.schedulePeriod;
          if (isEqual(schedulePeriod, 'N')) {
            scheduleContent = `한번 / ${this.getDateFormatter(scheduleData.scheduleStarttime)} 에 수행`;
          } else if (isEqual(schedulePeriod, 'D')) {
            scheduleContent = `매일 / ${TIME[scheduleData.scheduleHour].label}:${MINUTE[scheduleData.scheduleMinute].label} 에 수행`;
          } else if (isEqual(schedulePeriod, 'W')) {
            const scheduleIntervalDateArr = scheduleData.scheduleIntervalDate.split(',');
            let dateText = null;
            scheduleIntervalDateArr.forEach((string) => {
              if (isNil(dateText)) {
                dateText = `${WEEK[string - 1].label}`;
              } else {
                dateText = `${dateText},${WEEK[string - 1].label}`;
              }
            });
            scheduleContent = `매주 / ${dateText} / ${TIME[scheduleData.scheduleHour].label}:${MINUTE[scheduleData.scheduleMinute].label} 에 수행`;
          } else if (isEqual(schedulePeriod, 'M')) {
            const scheduleIntervalMonthArr = scheduleData.scheduleIntervalMonth.split(',');
            let monthText = null;
            scheduleIntervalMonthArr.forEach((string) => {
              if (isNil(monthText)) {
                monthText = `${MONTH[string - 1].label}`;
              } else {
                monthText = `${monthText},${MONTH[string - 1].label}`;
              }
            });
            const scheduleIntervalDateArr = scheduleData.scheduleIntervalDate.split(',');
            let dateText = null;
            scheduleIntervalDateArr.forEach((string) => {
              if (isNil(dateText)) {
                dateText = `${isEqual(string, 'E') ? '마지막' : string}일`;
              } else {
                dateText = `${dateText},${isEqual(string, 'E') ? '마지막' : string}일`;
              }
            });
            scheduleContent = `월간 / ${monthText} / ${dateText} / ${TIME[scheduleData.scheduleHour].label}:${MINUTE[scheduleData.scheduleMinute].label} 에 수행`;
          }
        }
        this.summaryFormData.scheduleContent = scheduleContent;
      }
      this.isLoaded = true;
    },
    executeAutodiscovery(executeType) {
      const params = {
        executeType,
        ipSearchList: this.checkedIpSearchRows,
        connectionList: this.checkedConnectionRows,
      };
      if (this.scheduleData.checkScheduleFlag) {
        params.scheduleData = this.scheduleData;
        params.scheduleData.scheduleContent = this.summaryFormData.scheduleContent;
      }
      DeviceRegistrationNmsAPI.executeAutodiscovery(params).then((response) => {
        if (response.data.success) {
          const modelingScanIds = [];
          forEach(params.ipSearchList, (item) => {
            modelingScanIds.push(item.scanId);
          });
          this.$store.dispatch('executeNetworkModelingTask', modelingScanIds);
          this.$message(msgUtil.getCustomResultMsgData('모델링을 수행합니다. 대량 장비를 모델링 할 경우 시간이 다소 소요될 수 있습니다.', true));
          this.$emit('click-back-button', true);
        } else {
          this.$message(msgUtil.getResultMsgData('수행', '모델링', false));
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData('수행', '모델링', false));
        throw e;
      });
    },
    clickPreStep() {
      this.$emit('click-pre-step');
    },
    scanTypeFormatter(value) {
      let result = null;
      if (!isNil(value)) {
        if (isEqual(value, 'SPOT')) {
          result = '단일 IP';
        } else if (isEqual(value, 'RANGE')) {
          result = 'IP 구간';
        } else {
          result = '서브넷마스크';
        }
      }
      return result;
    },
    getDateFormatter(value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Network/components/ModelingSummary.vue